import React from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Card } from "primereact/card";
import { useAuthStore } from "../../store/authStore";
import { useQuery } from "@tanstack/react-query";
import { productService } from "../../services/product";
import formatDate from "../../components/ui/dateFormat";
import { useNavigate } from "react-router-dom";
import ECard from "../../components/ui/ECard";
import { companyService } from "../../services/company";

const Dashboard = () => {
  const navigate = useNavigate();
  const { data: dispatchProducts, isLoading: dispatchLoading } = useQuery({
    queryKey: ["dispatchProducts", 30],
    queryFn: () =>
      productService.getDispatchProducts(30).then((res) => res.data),
  });

  const { data: warehouseProducts, isLoading: warehouseLoading } = useQuery({
    queryKey: ["warehouseProducts"],
    queryFn: () =>
      productService.getWarehouseProducts().then((res) => res.data),
  });

  const { data: users, isLoading: userLoading } = useQuery({
    queryKey: ["Users"],
    queryFn: () => companyService.getCurrentUsers(),
  });
  // Bugün için "YYYY-MM-DD" formatı
  const today = new Date().toISOString().slice(0, 10); // "2025-01-31"

  // Tarihi sadece gün, ay ve yıl kısmıyla eşleştirme fonksiyonu
  const extractDate = (dateString) => dateString?.slice(0, 10);

  // Sevk edilen ürünlerin toplam KG ve MT hesaplaması
  const totalDispatchKg = dispatchProducts
    ?.filter((product) => extractDate(product.sevkTar) === today)
    ?.reduce((acc, curr) => acc + (parseFloat(curr.sevkKg) || 0), 0);

  const totalDispatchMt = dispatchProducts
    ?.filter((product) => extractDate(product.sevkTar) === today)
    ?.reduce((acc, curr) => acc + (parseFloat(curr.sevkMt) || 0), 0);

  // Depodaki ürünlerin toplam KG ve MT hesaplaması
  const totalWarehouseKg = warehouseProducts
    ?.filter((product) => extractDate(product.tarih) === today)
    ?.reduce((acc, curr) => acc + (parseFloat(curr.kg) || 0), 0);

  const totalWarehouseMt = warehouseProducts
    ?.filter((product) => extractDate(product.tarih) === today)
    ?.reduce((acc, curr) => {
      // Virgülü kaldırıp parse ediyoruz
      const mtValue = parseFloat(curr.mt.replace(/,/g, "")) || 0;
      return acc + mtValue;
    }, 0);

  const contactDetails = [
    {
      icon: "pi pi-map-marker",
      label: "Adres",
      value: "Kurtuluş OSB, Taşlıyol Cd. No:3, 16580 Gürsu/Bursa",
    },
    {
      icon: "pi pi-phone",
      label: "Telefon",
      value: "(0224) 371 54 10",
    },
    {
      icon: "pi pi-envelope",
      label: "E-posta",
      value: "info@boyertekstil.com",
    },
  ];

  const formatNumber = (value) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };
  const mtBodyTemplate = (rowData) => {
    return formatNumber(rowData.sevkMt);
  };
  const kgBodyTemplate = (rowData) => {
    return formatNumber(rowData.sevkKg);
  };
  const partiBodyTemplate = (rowData) => {
    return (
      <div>
        {rowData.belgeNo} / {rowData.parti}
      </div>
    );
  };
  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.sevkTar);
  };
  return (
    <div className="grid justify-content-between m-1">
      <div className="col-12 md:col-4">
        <ECard
          loading={dispatchLoading}
          icon={
            <i
              className="pi pi-box"
              style={{ fontSize: "2.5rem", color: "green" }}
            />
          }
          title={"Bugün"}
          content={
            <div className="  text-color">
              <div className="flex gap-3">
                <div>
                  <span className="font-bold text-2xl">
                    {totalDispatchKg ? formatNumber(totalDispatchKg) : "0.00"}
                  </span>
                  <span className="font-semibold"> KG</span>
                </div>
                <div>
                  <span className="font-bold text-2xl">
                    {totalDispatchMt ? formatNumber(totalDispatchMt) : "0.00"}
                  </span>
                  <span className="font-semibold"> MT</span>
                </div>
              </div>
              <div className="text-right mt-3">
                <span> Ürün Hazırlandı</span>
              </div>
            </div>
          }
        />
      </div>
      <div className="col-12 md:col-4">
        <ECard
          loading={warehouseLoading}
          icon={
            <i
              className="pi pi-truck"
              style={{ fontSize: "2.5rem", color: "brown" }}
            />
          }
          title={"Bugün"}
          content={
            <div className="  text-color">
              <div className="flex gap-3 ">
                <div>
                  <span className="font-bold text-2xl">
                    {totalWarehouseKg ? formatNumber(totalWarehouseKg) : "0.00"}
                  </span>
                  <span className="font-semibold text-color"> KG</span>
                </div>
                <div>
                  <span className="font-bold text-2xl">
                    {totalWarehouseMt ? formatNumber(totalWarehouseMt) : "0.00"}
                  </span>
                  <span className="font-semibold"> MT</span>
                </div>
              </div>
              <div className="text-right mt-3">
                <span> Ürün Depoya Girdi</span>
              </div>
            </div>
          }
        />
      </div>

      <div className="col-12 md:col-4">
        <ECard
          loading={userLoading}
          icon={
            <i
              className="pi pi-user"
              style={{ fontSize: "2.5rem", color: "blue" }}
            />
          }
          title={"Toplam"}
          content={
            <div className="  text-color">
              <div className="flex gap-3">
                <div>
                  <span className="font-bold text-2xl">{users?.length}</span>{" "}
                </div>
              </div>
              <div className="text-right mt-3">
                <span> Aktif Kullanıcı</span>
              </div>
            </div>
          }
        />
      </div>

      {/* İletişim Bilgileri */}
      <div className="col-12 md:col-6">
        <ECard
          title={"İletişim Bilgileri"}
          content={
            <div className="  text-color">
              {contactDetails.map((detail, index) => (
                <li
                  key={index}
                  className="flex items-center gap-4 p-2 mt-2    rounded-md shadow-sm"
                >
                  <i className={`${detail.icon} text-blue-500 text-sm `}></i>
                  <div className="flex">
                    <span className="  font-semibold">{detail.label} : </span>
                    <span className="  text-sm"> {detail.value}</span>
                  </div>
                </li>
              ))}
            </div>
          }
        />
      </div>

      {/* Banka Bilgileri */}
      <div className="col-12 md:col-6">
        <ECard
          title={"Banka Bilgileri"}
          content={
            <div className="p-1 text-color ">
              <p>
                <span className="font-semibold text-sm ">
                  KUVEYT TÜRK KESTEL –BURSA ŞUBESİ
                </span>
              </p>
              <p>
                <strong>TL</strong> TR95 0020 5000 0001 5825 2000 03
              </p>{" "}
              <p>
                <strong>USD</strong> TR57 0020 5000 0001 5825 2001 05
              </p>
            </div>
          }
        />
      </div>

      {/* Son Kayıtlar Listeleri */}
      <div className="col-12 md:col-7">
        <DataTable
          value={(dispatchProducts || []).slice(0, 10)}
          loading={dispatchLoading}
          className="shadow-3 border-round-md table-content surface-ground"
          size="medium"
          emptyMessage="Liste Boş"
          scrollable
          scrollHeight="flex"
          header={() => (
            <div className="flex justify-content-between align-items-center">
              <span className="font-bold text-lg">
                Hazır Ürünler (Son 10 Ürün)
              </span>
              <Button
                label="Tümünü Gör"
                className="p-button-text"
                onClick={() => navigate("/admin/dispatch")}
              />
            </div>
          )}
        >
          <Column field="sevkTar" header="Tarih" body={dateBodyTemplate} />
          <Column field="urun" header="Ürün" />
          <Column field="kodu" header="İşlem" />
          <Column field="belgeNo" header="Parti" body={partiBodyTemplate} />
          <Column field="sevkKg" header="KG" body={kgBodyTemplate} />
          <Column field="sevkMt" header="MT" body={mtBodyTemplate} />
        </DataTable>
      </div>

      <div className="col-12 md:col-5 ">
        <DataTable
          value={(warehouseProducts || []).slice(0, 10)}
          emptyMessage="Liste Boş"
          loading={warehouseLoading || dispatchLoading}
          scrollable
          scrollHeight="flex"
          className="shadow-3 border-round-md table-content surface-ground"
          size="medium"
          header={() => (
            <div className="flex justify-content-between align-items-center">
              <span className="font-bold text-lg">
                Depodaki Ürünler (Son 10 Ürün)
              </span>
              <Button
                label="Tümünü Gör"
                className="p-button-text"
                onClick={() => navigate("/admin/warehouse")}
              />
            </div>
          )}
        >
          <Column field="tarihFormatted" header="Tarih" />
          <Column field="urun" header="Ürün" />
          <Column field="belgeNo" header="Parti No" body={partiBodyTemplate} />
          <Column field="kg" header="KG" />
          <Column field="mt" header="MT" />
        </DataTable>
      </div>
    </div>
  );
};

export default Dashboard;
